
export const DownloadFile = ( fileName: string, data: Blob ) => {

        const href = URL.createObjectURL( data );
                        
        const link = document.createElement('a');

        link.href = href;
        link.setAttribute('download', fileName);
        
        document.body.appendChild( link );

        link.click();

        document.body.removeChild( link );

        URL.revokeObjectURL( href );
}